<div class="wrapper" *ngIf="!batchSent; else confirmation">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Bulk Create Job</h4>
  </div>
  <div
    class="modal-body text-center job-template-modal"
    style="overflow: visible"
  >
    <div class="row modal-row d-flex" style="margin-bottom: 20px">
      <div class="col-sm-12 col-md-12 d-flex flex-column left-column">
        <label class="h5"
          >Jobs will be sent to:
          <strong>{{ conversations.length }} selected</strong>
          {{ conversations.length > 1 ? "workspaces" : "workspace" }}</label
        >
      </div>
    </div>
    <div class="row modal-row">
      <div class="col-sm-12 col-md-12 d-flex flex-column left-column">
        <i class="feather clipboard x3" style="color: #0075ff"></i>
        <p>
          Choose the template that will be created<br />across the selected
          workspaces:
        </p>
      </div>
    </div>
    <div class="row modal-row">
      <div class="col-sm-12 col-md-12 d-flex flex-column left-column">
        <form class="no-animation" [formGroup]="templatesForm">
          <input
            #templateListInput
            formControlName="templates"
            [typeahead]="templates"
            (typeaheadOnSelect)="typeaheadOnSelect($event)"
            [typeaheadOptionsLimit]="9999"
            [typeaheadMinLength]="0"
            typeaheadOptionField="name"
            placeholder="Choose template"
            class="form-control"
          />
        </form>
      </div>
    </div>

    <div class="row text-left mt-3" *ngIf="selectedJobTemplate">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Start date</label>
              <p-datepicker
                [(ngModel)]="jobStartDate"
                dateFormat="mm-dd-yy"
              ></p-datepicker>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Due date</label>
              <p-datepicker
                [(ngModel)]="jobDueDate"
                dateFormat="mm-dd-yy"
              ></p-datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </div>
    <button class="btn btn-primary pull-right" (click)="createJobs()">
      Create {{ conversations.length > 1 ? "Jobs" : "Job" }}
    </button>
  </div>
</div>

<ng-template #confirmation>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Bulk Create Job</h4>
  </div>
  <div
    class="modal-body text-center job-template-modal"
    style="overflow: visible"
  >
    <div class="row modal-row d-flex" style="margin-bottom: 20px">
      <div class="col-sm-12 col-md-12 d-flex flex-column left-column"></div>
    </div>
    <div class="row modal-row">
      <div class="col-sm-12 col-md-12 d-flex flex-column left-column">
        <h5>
          The {{ conversations.length > 1 ? "jobs are" : "job is" }} in process
          of being created.
        </h5>
        <p>This action may take a while if several workspaces were selected.</p>
      </div>
    </div>
    <div class="row modal-row">
      <div class="col-sm-12 col-md-12 d-flex flex-column left-column"></div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary pull-right" (click)="bsModalRef.hide()">
      OK
    </button>
  </div>
</ng-template>
